import React, { useState } from 'react';

const LocationDetails: React.FC = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="mt-2">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="text-sky-700 hover:text-sky-800 text-sm flex items-center mx-auto group"
      >
        <span>{isExpanded ? 'Hide Location Details' : 'See Location Details'}</span>
        <svg
          className={`ml-1 h-4 w-4 transform transition-transform duration-300 ease-in-out ${
            isExpanded ? 'rotate-180' : ''
          }`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>
      
      <div 
        className={`overflow-hidden transition-all duration-300 ease-in-out ${
          isExpanded ? 'max-h-96 opacity-100 mt-2' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="text-center text-gray-700 mb-3">
          <p className="font-medium">Seattle Children’s Museum</p>
          <p>Seattle Center</p>
          <a
            className="text-sky-700 hover:text-sky-800 underline"
            href="https://www.google.com/maps/search/?api=1&query=Seattle%20Children%27s%20Museum"
            target="_blank"
            rel="noopener noreferrer"
          >
            Open in Google Maps
          </a>
        </div>
      </div>
    </div>
  );
};

export default LocationDetails; 